import { client } from 'lib/evi-api-gateway';

import * as schoolTypes from 'types/school';

const school = `${process.env.REACT_APP_API_URL_RESOURCE}/api/school`;
const school_v2 = `${process.env.REACT_APP_API_URL_SCHOOL}/school`;

export async function get_all_class_list(params: schoolTypes.get_all_class_list_params) {
  return client.post({
    url: `${school}/get_all_class_list`,
    form: {
      ...params
    }
  });
}

export async function get_class_list(params: schoolTypes.get_class_list_params) {
  return client.post({
    url: `${school}/get_class_list`,
    form: {
      ...params
    }
  });
}

export async function get_year_list(params: schoolTypes.get_year_list_params) {
  return client.post({
    url: `${school_v2}/get_year_list`,
    form: {
      ...params
    }
  });
}
